import { Directive, Inject, OnInit, Input, ElementRef, OnChanges, Renderer2, Self, Host } from '@angular/core';
import {
  NgControl,
  ControlContainer,
  ValidationErrors,
  FormControl,
  NgForm,
  FormGroupDirective,
  FormGroup,
} from '@angular/forms';
// import { untilDestroyed } from 'ngx-take-until-destroy';
import { FormSubmitDirective } from './form-submit.directive';
import { merge, EMPTY, Observable } from 'rxjs';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { validateHorizontalPosition } from '@angular/cdk/overlay';
import { ErrorResponse, ERROR_TYPE } from '../../core';
import { getMultipleValuesInSingleSelectionError } from '@angular/cdk/collections';
import { ValidatorMessagePipe } from '../pipes/validator-message.pipe';

const VALIDATOR_PREFIX = 'validator.';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[validatorMessage]',
})
export class ValidatorMessageDirective implements OnInit, OnChanges {
  @Input() error: any;
  @Input() field: string;
  @Input() validators: string[];
  @Input() prefix: string;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private validatorMessagePipe: ValidatorMessagePipe
  ) {}

  ngOnInit() {
    this.renderer.addClass(this.el.nativeElement, 'error');
  }

  ngOnChanges() {
    console.log('!!! - errors : ', this.error);
    this.setError(
      this.error ? this.validatorMessagePipe.transform(this.error, this.field, this.validators, this.prefix) : null
    );
  }

  setError(message: string) {
    this.el.nativeElement.innerHTML = message;
    if (message) {
      this.renderer.removeClass(this.el.nativeElement, 'hide');
    } else {
      this.renderer.addClass(this.el.nativeElement, 'hide');
    }
  }
}
